export default __webpack_public_path__ + "static/media/vegan.83ea4ba3.svg";